(function($) {
    $('.page-list-plus-news .category-listing').on('click', 'a', function(e) {
        e.preventDefault();
        const bID = $(this).data('bid');
        const cID = $(this).data('cid');
        const $resultsContainer = $('#article-listing-' + bID);
        const $categoryContainer = $('#category-listing-' + bID);

        $categoryContainer.find(".active").removeClass('active');
        $(this).closest('li').addClass('active');

        $.get('/api/v1/page-list-plus/' + bID + '/' + cID, function(result) {
            $resultsContainer[0].scrollIntoView(true);
            $resultsContainer.replaceWith(result);
        });
    });

    $('.page-list-plus-news').on('click', '.ccm-pagination-wrapper a', function(e) {
        e.preventDefault();
        const $resultsContainer = $(this).closest('.article-listing');
        $.get($(this).attr('href'), function(result) {
            $resultsContainer[0].scrollIntoView(true);
            $resultsContainer.replaceWith(result);
        })
    });
})(jQuery);